export class GatewayPaymentSetup {

    refNo: number;
    provider: string;
    merchantId: string;
    secretKey: string;
    accessCode: string;
    companyCode: number;
}
